const encoder = new TextEncoder();
const decoder = new TextDecoder();

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);

  return btoa(String.fromCharCode(...bytes));
};

const base64ToArrayBuffer = (base64: string) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes.buffer;
};

const getEncryptionKey = async (secret: string) => {
  const hash = await crypto.subtle.digest('SHA-256', encoder.encode(secret));

  return crypto.subtle.importKey(
    'raw',
    hash,
    {
      name: 'AES-GCM',
    },
    false,
    ['encrypt', 'decrypt'],
  );
};

export const encryptString = async (
  value: string,
  secret: string,
): Promise<string> => {
  const key = await getEncryptionKey(secret);

  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encrypted = await crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
    },
    key,
    encoder.encode(value),
  );

  return JSON.stringify({
    iv: arrayBufferToBase64(iv.buffer),
    data: arrayBufferToBase64(encrypted),
  });
};

export const decryptString = async (
  encryptedValue: string,
  secret: string,
): Promise<string> => {
  const { iv, data } = JSON.parse(encryptedValue);

  const key = await getEncryptionKey(secret);

  const decrypted = await crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: new Uint8Array(base64ToArrayBuffer(iv)),
    },
    key,
    base64ToArrayBuffer(data),
  );

  return decoder.decode(decrypted);
};
